import JoinNow from './JoinNow';

export default JoinNow;
